import { BodyMediumRegular, BodyShortBold, TitleH3, TitleH4 } from '../typography'
import { ColumnFlexCentered, FlexCentered } from '~/components/common/containers'
import React, { useContext } from 'react'

import CheckIcon from '@8x8/oxygen-icon/icons/CheckIcon'
import CloudBarsIcon from '@8x8/oxygen-icon/icons/CloudBarsIcon'
import { Context } from '../context'
import LineChartIcon from '@8x8/oxygen-icon/icons/LineChartIcon'
import LinkIcon from '@8x8/oxygen-icon/icons/LinkIcon'
import { MAX_MOBILE_THRESHOLD } from '~/core/constants'
import MauTooltip from './mau-tooltip'
import PlanButton from './plan-button'
import ShieldIcon from '@8x8/oxygen-icon/icons/ShieldIcon'
import Spinner from '~/components/common/spinner'
import StarIcon from '@8x8/oxygen-icon/icons/StarIcon'
import styled from 'styled-components'
import { translate } from '~/core/translate'

const getFeatures = () => ([
  { title: translate('feature_authorized_access'), icon: ShieldIcon },
  { title: translate('feature_service_levels_2'), icon: CloudBarsIcon },
  { title: translate('feature_custom_ui_2'), icon: StarIcon },
  { title: translate('feature_webhooks'), icon: LinkIcon },
  { title: translate('feature_analytics'), icon: LineChartIcon },
  { title: translate('feature_gdpr_2'), icon: CheckIcon }
])

const StyledSpinner = styled(Spinner)`
  height: 325px;
`

const Features = styled.div`
  display: grid;
  grid-row-gap: 12px;
  grid-column-gap: 48px;
  margin-top: 24px;
`

const Feature = styled(FlexCentered)`
  span {
    margin-left: 8px;
  }
`

const BottomContainer = styled(ColumnFlexCentered)`
`

const ButtonContainer = styled(ColumnFlexCentered)`
  width: 240px;
`

const UsersTitle = styled(TitleH3)`
  margin: 8px auto;
`

const PlanIncludes = styled(BodyMediumRegular)`
  color: #040404;
  margin-top: 16px;
`

const Container = styled(ColumnFlexCentered)`
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.08), 0px 8px 24px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  color: black;
  margin: 32px 24px 16px;
  padding: 24px 16px;
  text-align: center;
  width: calc(100% - 48px);

  button {
    margin: 24px auto 8px;
  }

  @media screen and (min-width: ${MAX_MOBILE_THRESHOLD}) {
    width: 640px;

    button {
      max-width: 240px;
    }

    ${TitleH4} {
      max-width: 400px;
    }

    ${BottomContainer} {
      flex-direction: column-reverse;
    }

    ${Features} {
      grid-template-columns: repeat(2, 1fr);
    }
  }
`

const FreePlan = () => {
  const { products, getSession } = useContext(Context)

  if (!products.length) {
    return <StyledSpinner />
  }

  const freePlan = products.find(p => p.totalCost === 0)

  return (
    <Container>
      <TitleH4>Get started with our free plan. No credit card required.</TitleH4>
      <PlanIncludes>{translate('plan_includes')}</PlanIncludes>
      <UsersTitle>{freePlan.users}</UsersTitle>
      <MauTooltip>
        <BodyShortBold>{translate('mau')}</BodyShortBold>
      </MauTooltip>

      <BottomContainer>
        <ButtonContainer>
          <PlanButton
            isActive
            selectPlan={getSession}
            id={freePlan.id}
            name='free-plan'
          >
            {translate('continue')}
          </PlanButton>
        </ButtonContainer>
        <Features>
          {getFeatures().map(({ title, icon }) => {
            const Icon = icon
            return (
              <Feature key={title}>
                <Icon color='#929292' size={18} />
                <BodyMediumRegular>{title}</BodyMediumRegular>
              </Feature>
            )
          })}
        </Features>
      </BottomContainer>
    </Container>
  )
}

export default FreePlan
